import { useMutation, useQueryClient } from "@tanstack/react-query"
import { createCriteriaGroup } from "../../services/criteriaGroup";
import { IIndicators } from "../../types/indicator";
import { toast } from "react-toastify";

const useCreateCriteriaGroup = (indicator: IIndicators) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createCriteriaGroup,
        onMutate: () => {
            indicator.setIsProcessRunning(true);
            indicator.setIsServiceError(null);
        },
        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ['criteria-groups'] });
                indicator.setIsProcessRunning(false);
                indicator.setIsServiceError(null);
                toast.success("Criteria group created successfully");
            }
        },

        onError: (error: any) => {
            indicator.setIsServiceError(error?.response?.data?.message);
            indicator.setIsProcessRunning(false);
            toast.error(error?.response?.data?.message);
        }
    });
};

export default useCreateCriteriaGroup;